import { Map } from 'immutable';

const ModuleStateModel = Map({
  search: null,
  query: '',
  isFetchingResults: false,
  filter: 'default',
});

export default ModuleStateModel;
